<template>
  <div class="saasLogin">
    <img v-if="type === 1" src="../../assets/images/failed@2x.png" alt="" />
    <div v-else class="loading">
      <a-spin />
    </div>
    <div v-if="type === 1">登录失败 请稍后重试</div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue';
import { getUiFitment } from '@/utils/accessResources';

import api from '@/api';
import { post } from '@/utils/http';
import { getLogo } from '@/utils/intConfiguration';
import {
  setAccount,
  setUserSys,
  setToken,
  // eslint-disable-next-line import/extensions
} from '../login/login-handler.js';

const { envList } = require('../../../config/dev.proxy');

export default {
  components: {

  },
  data() {
    return {
      logoUi: getLogo(),
      args: this.getQueryStringSource(),
      type: 0, // 0-加载中 1-失败
    };
  },
  computed: {},
  created() {
  },
  mounted() {
    this.saasLoginLogin();
  },
  methods: {
    saasLoginLogin() {
      post(api.managerLogin, {
        appId: '10016',
        tenantId: this.args.tenantId,
      }).then((res) => {
        setToken(res);
        this.getLoginAccount(res);
      });
    },
    // 获取用户信息
    getLoginAccount(loginRes) {
      // debugger;
      post(api.loginAccount, {}).catch(() => {
        message.error('用户信息查询失败');
        this.type = 1;
      })
        .then((res) => {
          // 之后缓存菜单需要参数
          setAccount(res, loginRes);
          getUiFitment().finally(() => {
            if (res.id) {
              this.$store.commit('emptyTab');
              this.$router.push('/');
            } else {
              this.type = 1;
            }
          });
        });
    },
    getQueryStringSource(url) {
      // eslint-disable-next-line no-restricted-globals
      let qs = '';
      if (!url) {
        qs = window.location.search.length > 0 ? window.location.search.substring(1) : '';
      } else {
        qs = url;
      }
      // eslint-disable-next-line prefer-const
      let args = {};
      // eslint-disable-next-line prefer-const
      let items = qs.length ? qs.split('&') : [];
      let item = null;
      let name = null;
      let value = null;
      let i = 0;
      const len = items.length;
      // eslint-disable-next-line no-plusplus
      for (i = 0; i < len; i++) {
        item = items[i].split('=');
        name = decodeURIComponent(item[0]);
        value = decodeURIComponent(item[1]);
        if (name.length) {
          args[name] = value;
        }
      }
      return args;
    },
  },
};
</script>

<style lang="less" scoped>
.saasLogin {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // height: 100%;
  width: 400px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -60%, 0);

  img {
    display: block;
  }

  div {
    // position: absolute;
    text-align: center;
    font-size: 22px;
    margin-top: 16px;
  }
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
